<template>
  <div class="grid items-center" style="padding: 40px; height: calc(100dvh - 100px);">
    <div class="p-8 rounded-lg shadow-lg">
      <h3 class="mb-8 text-center" style="font-size: 20px; font-weight: 700">{{ user_name }}</h3>
      <p class="mb-4"><span style="font-weight: 500">현장명 : {{ field_name }}</span></p>
      <p class="mb-4"><span style="font-weight: 500">{{ $t('업체명 :') }}</span>{{ com_name }}</p>
      <p class="mb-4"><span style="font-weight: 500">{{ $t('직책 :') }}</span>{{ rank }}</p>
      <p class="mb-4"><span style="font-weight: 500">{{ $t('직종 :') }}</span>{{ section }}</p>
      <div class="mb-4 p-12 flex justify-center items-center" style="background: #28C76F; border-radius: 8px; font-size: 28px; color: #fff; font-weight: 500" @click="checkIn">
        <feather-icon icon="LogInIcon" class="mr-2 pr-4" style="scale: 2"></feather-icon>{{ $t('출근') }}</div>
      <div class="flex p-12 justify-center items-center" style="background: #EA5455; border-radius: 8px; font-size: 28px; color: #fff; font-weight: 500" @click="checkOut">
        <feather-icon icon="LogOutIcon" class="mr-2 pl-4" style="scale: 2; transform: rotateY(180deg)"></feather-icon>{{ $t('퇴근') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QrScanCheckInOut',
  props: {
    data: Object,
  },
  computed:{
    field_name(){
      return this.data.field_name || '-';
    },
    user_name(){
      return this.data.user_name || '-';
    },
    com_name(){
      return this.data.com_name || '-';
    },
    rank(){
      return this.data.rank || '-';
    },
    section(){
      return this.data.section || '-';
    }
  },
  data() {
    return {
      list: [
        {
          id: 1,
          title: '인원·장비 투입 QR 스캔',
          description: '일 투입 현황 출입 기록용 스캔',
        },
        {
          id: 2,
          title: '안전·보건 교육 QR 스캔',
          description: '안전·보건 교육 근로자 이수 기록용 스캔',
          disabled: true
        }
      ]
    };
  },
  methods: {
    checkIn () {
      this.$emit("checkIn", this.data)
    },
    checkOut () {
      this.$emit("checkOut", this.data)
    },
  }
}
</script>

<style scoped lang="scss">

</style>
